import { Button, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, Text, useColorModeValue } from '@chakra-ui/react';
import { LoadingSpinner } from '@bluefalcon/components-package';

type ConfirmModalProps = {
    onConfirm: () => Promise<void>;
    onCancel: () => void;
    message: string;
    isLoading?: boolean;
    confirmBtnMessage?: string;
    confirmBtnColor?: 'primary' | 'success' | 'warning' | 'danger' | 'info';
    isOpen: boolean;
    onClose: () => void;
};

export const ConfirmModal = ({
    onConfirm,
    onCancel,
    message,
    isLoading,
    confirmBtnMessage,
    confirmBtnColor = 'danger',
    isOpen,
    onClose,
}: ConfirmModalProps) => {
    const modalBg = useColorModeValue('white', 'gray.700');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const textColor = useColorModeValue('gray.800', 'gray.200');

    const submit = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent
                bg={modalBg}
                borderColor={borderColor}
                borderRadius="md"
                boxShadow="md"
                p={4}
                maxWidth="sm"
                textAlign="center"
            >
                <ModalCloseButton />
                <ModalBody>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <>
                            <Text fontSize="lg" mb={4} color={textColor}>
                                {message}
                            </Text>
                            <Flex justifyContent="space-between">
                                <Button variant="outline" onClick={onCancel} colorScheme="gray">
                                    Cancel
                                </Button>
                                <Button
                                    onClick={submit}
                                    color='white'
                                    variant='solid'
                                    bgColor={`${confirmBtnColor}.500`}
                                    _hover={{ bgColor: `${confirmBtnColor}.600` }}
                                >
                                    {confirmBtnMessage ?? 'Delete'}
                                </Button>
                            </Flex>
                        </>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
